import { createSlice } from '@reduxjs/toolkit';

const childrenSlice = createSlice({
    name: 'children',
    initialState: {
        list: [],
        loading: false,
    },
    reducers: {
        setChildren: (state, action) => {
            state.list = action.payload;
        },
    },
});

export const { setChildren } = childrenSlice.actions;
export default childrenSlice.reducer;